import rawCatalog from '../../audio-metadata.json';

export type Track = {
  track_id: string;
  name: string;
  category: string;
  mental_state: string | null;
  activity: string | null;
  duration_seconds: number;
  beats_per_minute: number | null;
  brightness_level: number | null;
  complexity_level: number | null;
  neural_effect_level: number | null;
  filename: string;
  relative_path: string;
};

type RawCatalog = { items: Track[]; category_counts: Record<string, number> };

export const catalog = (rawCatalog as RawCatalog).items;
export const categoryCounts = (rawCatalog as RawCatalog).category_counts;
export const categories = ['All', ...Object.keys(categoryCounts)];

export function slugifyCategory(category: string): string {
  return category.toLowerCase().replace(/\s+/g, '-').replace(/&/g, 'and');
}

export function audioKey(track: Track): string {
  const relative = track.relative_path.replace(/^outputs\//, '');
  return relative || `audio/${slugifyCategory(track.category)}/${track.filename}`;
}

export function audioUrl(track: Track): string {
  const baseUrl = (import.meta.env.VITE_AUDIO_BASE_URL ?? '/').replace(/\/$/, '');
  return `${baseUrl}/${audioKey(track)}`;
}

export function formatDuration(seconds: number): string {
  const safeSeconds = Number.isFinite(seconds) ? Math.max(0, Math.round(seconds)) : 0;
  const minutes = Math.floor(safeSeconds / 60);
  const remaining = safeSeconds % 60;
  return `${minutes}:${remaining.toString().padStart(2, '0')}`;
}

export function formatFocusTime(seconds: number): string {
  const safeSeconds = Math.max(0, Math.round(seconds));
  const hours = Math.floor(safeSeconds / 3600);
  const minutes = Math.floor((safeSeconds % 3600) / 60);
  const remaining = safeSeconds % 60;
  if (hours > 0) return `${hours}:${minutes.toString().padStart(2, '0')}:${remaining.toString().padStart(2, '0')}`;
  return `${minutes.toString().padStart(2, '0')}:${remaining.toString().padStart(2, '0')}`;
}
